import React from 'react';
import BidPackInfo from "../../code/models/BidPackInfo";
import ApiDocument from "../../code/api/ApiDocument";
import BidPeriodFileGroupInfo from "../../code/models/BidPeriodFileGroupInfo";

interface IAdminBidPackImport {
    bidPackInfo: BidPackInfo;
    onRefreshRequest: Function;
}


export default function AdminBidPackImport({ bidPackInfo, onRefreshRequest }: IAdminBidPackImport) {
    const [currentFileGroup, setCurrentFileGroup] = React.useState<BidPeriodFileGroupInfo | null | undefined>();
    const [disableImportButton, setDisableImportButton] = React.useState<boolean>(false);

    React.useEffect(() => {
        var fg = bidPackInfo.fileGroup || bidPackInfo.lastFileGroup;
        setCurrentFileGroup(fg);

        if (!fg || fg.bidPeriodFiles.length === 0) {
            setDisableImportButton(true);
        } else {
            var stat = (fg?.groupStatus || "").toLowerCase();
            if (stat !== "ready" && stat !== "error") {
                setDisableImportButton(true);
            }
        }

    }, []);

    function handleImportBidPacks() {
        setDisableImportButton(true);
        if (!!bidPackInfo.fileGroup) {
            ApiDocument.queueImportRequest(bidPackInfo.fileGroup.bidPeriodFileGroupId).then(resp => {
                onRefreshRequest();
            }).finally(() => {
                setDisableImportButton(false);
            });
        }
    }

    return (
        <React.Fragment>
            <div>
                <span className="creditrange-label">Last Import Date:</span>
                {!bidPackInfo.importRequest &&
                    <span className="creditrange-data">None for this bid period.</span>}
                {!!bidPackInfo.importRequest &&
                    <span className="creditrange-data">{new Date(bidPackInfo.importRequest?.statusDate).toLocaleString()}</span>}
            </div>
            <div>
                <span className="creditrange-label">Last Import Status:</span>
                {!bidPackInfo.importRequest && <span className="creditrange-data">N/A</span>}
                {!!bidPackInfo.importRequest && <span className="creditrange-data">{bidPackInfo.importRequest?.status}</span>}
            </div>
            <div>
                <span className="creditrange-label">Last Import Message:</span>
                {!bidPackInfo.importRequest && <span className="creditrange-data">N/A</span>}
                {!!bidPackInfo.importRequest && <span className="creditrange-data">{bidPackInfo.importRequest?.statusMessage}</span>}
            </div>
            <br />
            <div>
                <span className="creditrange-label">Last Bid Pack Group Date:</span>
                {!currentFileGroup && <span className="creditrange-data">None for this bid period.</span>}
                {!!currentFileGroup &&
                    <span className="creditrange-data">{new Date(currentFileGroup.statusDate).toLocaleString()}</span>}
            </div>
            <div>
                <span className="creditrange-label">Last Bid Pack Group Status:</span>
                {!currentFileGroup && <span className="creditrange-data">N/A</span>}
                {!!currentFileGroup && <span className="creditrange-data">{currentFileGroup.groupStatus}</span>}
            </div>
            <div>
                <span className="creditrange-label">Total Bid Pack Files:</span>
                {!currentFileGroup && <span className="creditrange-data">N/A</span>}
                {!!currentFileGroup && <span className="creditrange-data">{currentFileGroup.bidPeriodFiles.length}</span>}
            </div>
            <div className="bidpackimport-btngroup"><button className="btn btn-primary btn-md" disabled={disableImportButton}
                onClick={handleImportBidPacks}>Import Bid Packs</button>
            </div>
        </React.Fragment>
    )
}

